import React, { useMemo, lazy, Suspense } from "react";

const useSvgComponent = (svgAssetPath) => {
  const SvgComponent = useMemo(() => {
    const ImportedSvg = lazy(async () => {
      const module = await import(`@client.images/${svgAssetPath}.svg`);

      return { default: module.ReactComponent };
    });

    const WrapperComponent = (props) => (
      <Suspense fallback={<div></div>}>
        <ImportedSvg {...props} />
      </Suspense>
    );

    return React.memo(WrapperComponent);
  }, [svgAssetPath]);

  return SvgComponent;
};

export default useSvgComponent;
